__turbopack_context__.v({
  "Root": "_8OgQxW_Root",
  "skeleton-loading": "_8OgQxW_skeleton-loading",
});
